import PageTemplate from '../components/PageTemplate';

const StocksPage = () => (
  <PageTemplate
    page="stocks"
    pageName="Stocks"
    tagline="Let your money work as hard as you do."
    icon="📈"
    accentColor="#C9A84C"
    about={{
      title: 'Financial Wisdom for the Long Game',
      paragraph1: 'Financial investment is the mechanism through which we create the resources to fund every other kind of investment in our lives and communities.',
      paragraph2: 'We provide thoughtful, values-aligned market insights that help you build lasting wealth without compromising your principles.',
      points: [
        'Value investing and long-term wealth building',
        'ESG investing: aligning money with values',
        'Diversification strategies and risk management',
        'Understanding market cycles and patience',
      ]
    }}
  />
);

export default StocksPage;
